import type React from "react";
import type { CSSProperties } from "react";

import { cx, styled } from "simplydo/react/styled";
import { Icon, Popup, type SemanticICONS } from "simplydo/react/ui";

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 0.5px solid #c9c9c9;
  border-radius: 5px;
  background-color: #fff;
  padding: 6px 3px;
`;

export const ActionArea = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 5px 5px 0 5px;
  border-top: 0.5px solid silver;
  padding-top: 5px;
  > div {
    display: flex;
    align-items: center;
  }
  > .ui.button {
    margin: 0;
  }
  i {
    margin: 0 0 3px 0;
  }
`;

export const StyledActionButton = styled.div`
  padding: 3px 7.5px;
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 33px;
  cursor: default;
  opacity: 1;
  &.is-disabled {
    opacity: 0.5;
  }
  &:not(.is-disabled) {
    cursor: pointer;
    &:hover {
      background-color: #e9ebee;
    }
  }
  span {
    display: block;
    margin-right: 7.5px;
    color: gray;
    font-weight: 600;
    text-transform: uppercase;
  }
  i {
    color: gray;
    height: 1.2em;
    font-size: 1.2em;
    margin: 0;
  }
`;

type ActionButtonProps = {
  title?: string;
  position?:
    | "top center"
    | "top left"
    | "top right"
    | "bottom right"
    | "bottom left"
    | "right center"
    | "left center"
    | "bottom center";
  iconName: SemanticICONS;
  content?: string;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  loading?: boolean;
  style?: CSSProperties;
};

export const ActionButton = ({
  title,
  position,
  iconName,
  content,
  disabled,
  onClick,
  loading: _loading,
  style,
}: ActionButtonProps) => (
  <Popup
    position={position || "top center"}
    content={title}
    disabled={!title}
    trigger={
      <StyledActionButton
        {...(!disabled && onClick ? { onClick } : {})}
        className={cx(disabled && "is-disabled")}
        style={style}
      >
        {content ?
          <span>{content}</span>
        : null}
        <Icon name={iconName} />
      </StyledActionButton>
    }
  />
);
